/**
 * Calculates the total for a payment
 *
 * @param {object} payment
 * @param {string} gstStatus Manager fee gst status
 */
function calculateTotal(payment) {
  let feeTotal = 0

  if (payment.fee.length > 0) {
    payment.fee.forEach((fee) => {
      feeTotal += Number(fee.fee_real)
      feeTotal += Number(fee.fee_gst)
    })
  }

  return (
    payment.pay_amount -
    payment.manager_fee_real -
    payment.manager_fee_gst -
    feeTotal
  ).toFixed(2)
}

function calculateManagerFeeGst(payment) {
  if (payment.mf_gst_status === 0) {
    payment.manager_fee_gst = 0
  } else if (payment.mf_gst_status === 2) {
    payment.manager_fee_gst = (payment.manager_fee * 0.15).toFixed(2)
  }

  return payment.manager_fee_gst
}

function outputPdfAtNewTab(response, filename) {
  let blob = new Blob([response.data], { type: 'application/pdf' })
  const url = window.URL.createObjectURL(blob)

  try {
    let newTab = window.open()
    newTab.location.href = url
    setTimeout(() => {
      if (newTab.closed) {
        let link = document.createElement('a')
        link.href = url
        link.download = filename || 'report.pdf'
        link.click()
      }
    }, 200)
  } catch (e) {
    let link = document.createElement('a')
    link.href = url
    link.download = filename || 'report.pdf'
    link.click()
  }
}

function hasUnprocessedPayments(payments) {
  if (payments.length > 0) {
    const unprocessed = payments.filter(payment => payment.state < 1)
    return unprocessed.length > 0
  }
  return false
}

function hasCashPays(payments) {
  if (payments.length > 0) {
    const cashpays = payments.filter(payment => !!payment.paycash)
    return cashpays.length > 0
  }
  return false
}

function hasNegativePayments(payments) {
  if (payments.length > 0) {
    const negative = payments.filter(payment => payment.total_amount < 0)
    return negative.length > 0
  }
  return false
}

function hasUnknownOwnerAccount(payments) {
  if (payments.length > 0) {
    const unknown = payments.filter(payment => !payment.owner_bank_account)
    return unknown.length > 0
  }
  return false
}

export default {
  calculateTotal,
  calculateManagerFeeGst,
  outputPdfAtNewTab,
  hasUnprocessedPayments,
  hasNegativePayments,
  hasCashPays,
  hasUnknownOwnerAccount
}
